import React from "react";

import classNames from "classnames";
import { Field } from "formik";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import { ReactComponent as IconError18 } from "../../../icons/icon/18/a-icon-error-18.svg";

import "./radioButtons.scss";

const RadioButtons = ({
  errors,
  hideLabel,
  id,
  isRequired,
  options,
  title = null,
  touched,
}) => {
  const radioOptions = options ? options.map((e) => (e && typeof e === "object" ? { label: e.label, value: e.value } : { label: e, value: e })) : [];

  return (
    <>
      {title && !hideLabel && (
        <p className={classNames("typo-label", { "required-sign": isRequired })}>
          {title}
        </p>
      )}
      <Form.Group
        className="radio-form w-100"
      >
        {radioOptions.map((option) => (
          <Form.Label key={option.value} className="radio-form__label">
            <Field type="radio" name={id} value={option.value} label={option.label} className="mr-9" />
            {option.label}
          </Form.Label>
        ))}
        <Form.Text
          className={classNames({ "invalid-feedback": (errors[id] && touched[id]) })}
        >
          {errors[id] && touched[id]
            ? <div><IconError18 />{errors[id]}</div>
            : <>{!isRequired && <FormattedMessage id="form.optional" />}</>}
        </Form.Text>
      </Form.Group>
    </>
  );
};

RadioButtons.propTypes = {
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  hideLabel: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  options: PropTypes.oneOfType([PropTypes.array]).isRequired,
  title: PropTypes.string,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default RadioButtons;
